import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { Typography, FormControlLabel, Checkbox, Box, Button } from "@material-ui/core";
import {
  fetchAccreditationDetailForms,
  fetchQADetailForms,
  UnassignFormsToOdkUser,
  fetchOdkUserAssignment,
} from "../actions";

const styles = (theme) => ({
  paper: theme.paper.paper,
  title: theme.paper.title,
  page: theme.page,
});

class UnAssignFormsUserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formToPublish: [],
    };
  }

  componentDidMount() {
    const { projectId, detailUuid, userUuid, detailType } = this.props;
    if (projectId) {
      if (detailType === "qa") {
        this.props.fetchQADetailForms(projectId);
      } else {
        this.props.fetchAccreditationDetailForms(projectId);
      }
    }
    if (userUuid) {
      this.props.fetchOdkUserAssignment(userUuid);
    }
  }

  handleCheckboxChange = (uuid) => {
    this.setState((prevState) => {
      const { formToPublish } = prevState;
      return {
        formToPublish: formToPublish.includes(uuid)
          ? formToPublish.filter((id) => id !== uuid)
          : [...formToPublish, uuid],
      };
    });
  };

  handleUnassignForms = () => {
    const { UnassignFormsToOdkUser, userUuid, detailUuid, detailType } = this.props;
    const { formToPublish } = this.state;
    if (!formToPublish.length) return;
    UnassignFormsToOdkUser(formToPublish, detailUuid, userUuid, detailType, "Unassigned Form From User");
    this.setState({ formToPublish: [] });
  };

  isActionDisabled = () => !this.state.formToPublish.length || !this.props.detailUuid;

  render() {
    const {
      classes,
      accreditationDetailsForms,
      errorAccreditationDetailsForms,
      detailType,
      qaDetailsForms,
      errorQADetailsForms,
      odkUserAssignments = [],
    } = this.props;

    const { formToPublish } = this.state;

    const formList = detailType === "qa" ? qaDetailsForms || [] : accreditationDetailsForms || [];
    const error = detailType === "qa" ? errorQADetailsForms : errorAccreditationDetailsForms;

    const assignedFormUUIDs = Array.isArray(accreditationDetailsForms)
      ? new Set(accreditationDetailsForms?.map((edge) => edge.odkForm.uuid))
      : new Set(qaDetailsForms?.map((edge) => edge.odkForm.uuid));

    const assignedForms = formList.filter((form) => assignedFormUUIDs.has(form?.odkForm?.uuid));

    return (
      <div style={{ width: "100%" }}>
        <Typography className={classes.title}>Assigned Forms</Typography>

        {error && <Typography color="error">Error loading forms: {error.message || "Unknown error"}</Typography>}

        {!assignedForms?.length ? (
          <Typography>No assigned forms to unassign</Typography>
        ) : (
          <div>
            {assignedForms.map((form, index) => (
              <div key={form.uuid || index} style={{ width: "100%" }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      value={form.uuid}
                      onChange={() => this.handleCheckboxChange(form.uuid)}
                      checked={formToPublish.includes(form.uuid)}
                    />
                  }
                  label={form.odkForm.formName}
                />
              </div>
            ))}

            <Box display="flex" justifyContent="flex-end" mt={2}>
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleUnassignForms}
                disabled={this.isActionDisabled()}
              >
                Unassign Forms
              </Button>
            </Box>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  accreditationDetailsForms: state.quality_assurance_and_accreditation?.accreditationDetailsForms || [],
  errorAccreditationDetailsForms: state.quality_assurance_and_accreditation?.errorAccreditationDetailsForms,
  qaDetailsForms: state.quality_assurance_and_accreditation?.qaDetailsForms || [],
  errorQADetailsForms: state.quality_assurance_and_accreditation?.errorQADetailsForms,
  assigningForms:
    state.quality_assurance_and_accreditation?.assigningForms ||
    state.quality_assurance_and_accreditation?.assigningForms,
  assignFormsSuccess:
    state.quality_assurance_and_accreditation?.assignFormsSuccess ||
    state.quality_assurance_and_accreditation?.assignFormsSuccess,
  assignFormsError:
    state.quality_assurance_and_accreditation?.assignFormsError ||
    state.quality_assurance_and_accreditation?.assignFormsError,
  odkUserAssignments: state.quality_assurance_and_accreditation.odkUserAssignments || [],
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchAccreditationDetailForms,
      fetchQADetailForms,
      UnassignFormsToOdkUser,
      fetchOdkUserAssignment,
    },
    dispatch,
  );

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(UnAssignFormsUserList));
